<div class="spinner" [ngClass]="{small: small}">
  <div class="dot1"></div>
  <div class="dot2"></div>
</div>

<div class="spinner-content">
  <ng-content></ng-content>
</div>